import { TYPOGRAPHY } from "@store/theme/common/design";

export default {
    typography: {
        fontFamily: TYPOGRAPHY.fontFamily,
        weight: TYPOGRAPHY.weight,
        size: TYPOGRAPHY.size,
        lineHeight: TYPOGRAPHY.lineHeight,
    },
};
